// Module
var code = "<h2 id=\"youcandealwithitcom\">YouCanDealWithIt.com</h2> <p><a href=\"https://www.youcandealwithit.com/\">YouCanDealWithIt.com</a> has great tips and information for those who may have troubling managing student loan debt.</p> ";
// Exports
export default code;